export enum ImgConf  {
  DownCode = '/code.png',
}
